<h3 data-cy="form-builder-open-title">Select a Form To Edit</h3>

<table style="width: 100%;" data-cy="form-builder-open-table">

  <tr data-cy="form-builder-open-main-row">
    <td style="width: 50%; vertical-align: top; " data-cy="form-builder-open-forms-cell">
      <div style="float: left;" data-cy="form-builder-open-forms-container">

            <dx-list style="margin: 5px"
              [dataSource]="forms"
              [searchEnabled]="true"
              keyExpr="DFormId"
              displayExpr="DFormName"
              searchExpr="DFormName"
                     pageLoadMode="scrollBottom"
                     [selectedItemKeys]="selectedFormKeys"
              height="450"
                     selectionMode="single"
                     (onSelectionChanged)="onFormSelectionChanged($event)"
                     data-cy="form-builder-open-forms-list"
            >
            </dx-list>


      </div>
    </td>
    <td style="width: 50% ; vertical-align: top;" data-cy="form-builder-open-versions-cell">

      <div style="float: left;" data-cy="form-builder-open-versions-container">

        <p *ngIf="!selectedForm" data-cy="form-builder-open-no-form-message">No Form Selected</p>
        <p *ngIf="selectedForm" data-cy="form-builder-open-selected-form-name">{{selectedForm?.DFormName}}</p>


        <span data-cy="form-builder-open-versions-label">Versions:</span>
        <dx-list style="margin: 5px"
                 [dataSource]="formVersions"
                 keyExpr="DFormVersionId"
                 displayExpr="Version"
                 pageLoadMode="scrollBottom"
                 height="300"
                 [selectedItemKeys]="selectedFormVersionKeys"
                 data-cy="form-builder-open-versions-list"
        >

        </dx-list>

      </div>

    </td>


  </tr>
  <tr data-cy="form-builder-open-actions-row">
    <td style="margin-top: 15px;" data-cy="form-builder-open-form-actions-cell">
      <dx-button
        icon="add"
        (onClick)="onAddFormClick()"
        data-cy="form-builder-open-add-form-button"
      >
      </dx-button>
      <dx-button
        icon="remove"
        (onClick)="onDeleteFormClick()"
        data-cy="form-builder-open-delete-form-button"
      >
      </dx-button>
      <dx-button
        icon="copy"
        (onClick)="onDuplicateFormClick()"
        data-cy="form-builder-open-duplicate-form-button"
      >
      </dx-button>


    </td>
    <td data-cy="form-builder-open-version-actions-cell">
      <dx-button
        icon="add"
        (onClick)="onAddFormVersionClick()"
        data-cy="form-builder-open-add-version-button"
      >

      </dx-button>
    </td>

  </tr>

  <tr data-cy="form-builder-open-bottom-row">
    <td data-cy="form-builder-open-empty-cell">
    </td>
    <td style="horiz-align: right" data-cy="form-builder-open-confirm-cell">


      <div style="float: right;" data-cy="form-builder-open-confirm-container">
        <dx-button id="btnSelectForm"
          text="Select"
                   (onClick)="onFormVersionSelectClick()"
                   data-cy="form-builder-open-select-button"
        >

        </dx-button>


        <dx-button
          text="Cancel"
          (onClick)="onFormVersionCancelClick()"
          data-cy="form-builder-open-cancel-button"
        >
        </dx-button>

      </div>


    </td>

  </tr>

</table>
